import { getAuth } from "firebase/auth";
import { collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../helpers/HelperForMetaData";

const updateAgentStatus = async (clientId, agentId) => {
  try {
    let agentDoc = await doc(db, "clients", clientId);
    agentDoc = await collection(agentDoc, "agents");
    agentDoc = await doc(agentDoc, agentId);
    const data = {
      status: "active",
      uid: getAuth().currentUser.uid,
      ...HelperForMetaData({}),
    };
    delete data.createdAt;
    delete data.createdBy;
    return await updateDoc(agentDoc, data)
      .then((res) => true)
      .catch((err) => false);
  } catch (error) {
    console.log(error);
  }
};

export default updateAgentStatus;
